export default { "backEndUrl": 'https://api.test.curapp.org/', "devEnvironment": false }